import { Component, Inject, OnInit } from '@angular/core';
import { SrDetalle } from 'src/app/interfaces/srDetalle';
import { FormsModule } from '@angular/forms';
import { promise } from 'selenium-webdriver';
import { Sr } from 'src/app/interfaces/sr';
import { SrService } from 'src/app/service/sr.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Cell, Columns, Img, PdfMakeWrapper, QR, Table, Txt} from 'pdfmake-wrapper';
import {ITable, ICell} from 'pdfmake-wrapper/lib/interfaces';
import { DecimalPipe } from '@angular/common';
import { pipe } from 'rxjs';
import { pdfMake } from 'pdfmake/build/vfs_fonts';
import { Column, TableCell } from 'pdfmake/interfaces';
import { Direccion } from 'src/app/interfaces/direccion';
import { ClienteService } from 'src/app/service/cliente.service';
import { DireccionService } from 'src/app/service/direccion.service';
import { Cliente } from 'src/app/interfaces/cliente';

// import pdfFronts from "pdfmake/build/vfs_fonts";



@Component({
  selector: 'app-sr-form',
  templateUrl: './sr-form.component.html',
  styleUrls: ['./sr-form.component.css']
})
export class SrFormComponent implements OnInit {
  sr:Sr;
  srD:SrDetalle;
  listSrD:SrDetalle[] ;
  direcciones:Direccion[]=Array<Direccion>();
  alertadetalle:boolean=false;
  cliente:Cliente;
  direccionActiva:Direccion;

  public id = Object.assign({id: 12, name: 'Mariano'});

  showSecondView:number = 1;

  constructor(private srService:SrService,private clienteService:ClienteService,private direccionService:DireccionService, private dialogRef: MatDialogRef<SrFormComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.sr={
      dni:0,
      id_remitente:0,
      origen_nombre:"",
      email:"",
      telefono:0,
      origen_provincia:"",
      origen_localidad:"",
      origen_direccion:"",
      origen_altura:0,
      origen_cp:"",
      origen_piso_departamento:"",
      id_franja_horaria:1,
      destino_cuit:0,
      destino_nombre:"",
      destino_telefono:0,
      destino_provincia:"",
      destino_localidad:"",
      destino_direccion:"",
      destino_entrecalles:"",
      destino_altura:0,
      destino_cp:"",
      destino_email:"",
      destino_piso_departamento:"",
      is_contrareembolso:false,
      contrareembolso_valor:0,
      contrareembolso_pago:false
    };
    this.srD={
      id_sr: 0,
      id_bulto:0,
      observacion:'-',
      valor_declarado:0,
      peso:0,
      estado:1
    };
     this.direccionActiva={id:0,id_cliente:0,provincia:'',localidad:'',direccion:'',estado:1,cp:'',piso_dpto:'',telefono:0,observacion:'',nombre:''};

    this.cliente={email:'',token:'', estado:1}
    clienteService.getbytoken().then((item:Cliente)=>{
      if(item.dni && item.nombres){
        this.cliente=item;
        this.sr.dni=item.dni;
        this.sr.email=item.email;
        this.sr.origen_nombre=item.nombres;
        this.sr.id_remitente=item.id;
        this.direccionService.getByCliente().then((dir:any)=>{
          this.direcciones=dir;
          if(this.direcciones[0].id){
            this.direccionActiva=this.direcciones[0];
            this.cargarDireccion();
          }

        });
      }


    });
    console.log('el id: '+data.id);
    if(data.id>0){
      this.srService.getById(data.id).subscribe((element:Sr) =>{
        if(element.origen_piso_departamento===null){
          element.origen_piso_departamento="";
        }
        this.sr=element;
        console.log(this.sr);
        this.srService.getDetalle(data.id).subscribe((detalle:any)=>{
        this.listSrD=detalle;
        });
      });

    }



    this.listSrD=new Array<SrDetalle>();



  }

  ngOnInit(): void {
  }
  async crearpdf(){


  const pdf =new PdfMakeWrapper();
  let logo= await new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).build();
  pdf.background(logo);

  let prueba: Column[];
  // prueba=new Array<Column>{}

  pdf.add(this.createTableOrigen(await new Img(logo.image).height(45).width(40).build()));//info del destinatario
    pdf.add(new Table([
      ['Bulto','Descripcion', 'Peso','Valor'],
      ...this.extraerData()
    ]).layout('lightHorizontalLines').alignment('center').end);// info de los bultos

    pdf.add(this.createTableDestino())//info del destino
    pdf.header(new Txt('Fecha: ' + this.sr.updated_at?.substring(0,10)).alignment('right').end);
    pdf.footer(new Table([
      ['Firma: ','','Firma Conductor: ',''],
      ['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],['','','',''],
      ['Aclaracion: ','','Aclaracion Conductor: ','']

    ]).alignment('justify').widths(['*',100,'*',100])
    .heights((row:number) =>{return row+100} )
    .layout('noBorders').margin([50,0])
    .end
    );
    pdf.pageMargins([40,40,40,100])
    pdf.add(new QR('http://manager.crabslogistica.ar/cliente/'+this.sr.id+'/0').alignment('center').pageBreak('after').end)



    pdf.add(this.createTableOrigen(await new Img(logo.image).height(45).width(40).build()));//info del destinatario
    pdf.add(new Table([
      ['Bulto','Descripcion', 'Peso','Valor'],
      ...this.extraerData()
    ]).layout('lightHorizontalLines').alignment('center').end);// info de los bultos

    pdf.add(this.createTableDestino())//info del destino

    pdf.pageMargins([40,40,40,100])
    pdf.add(new QR('http://manager.crabslogistica.ar/cliente/'+this.sr.id+'/0').alignment('center').pageBreak('after').end)


    pdf.add(this.createTableOrigen(await new Img(logo.image).height(45).width(40).build()));//info del destinatario
    pdf.add(new Table([
      ['Bulto','Descripcion', 'Peso','Valor'],
      ...this.extraerData()
    ]).layout('lightHorizontalLines').alignment('center').end);// info de los bultos

    pdf.add(this.createTableDestino())//info del destino

    pdf.pageMargins([40,40,40,100])
    pdf.add(new QR('http://manager.crabslogistica.ar/cliente/'+this.sr.id+'/0').alignment('center').end)
  pdf.create().open();

}
extraerData():any[]{
  return this.listSrD.map(row=>[row.id_bulto,row.observacion,row.peso,row.valor_declarado])
}
  createTableOrigen(logo:any): ITable{
    let valContrareembolso='NO';
    if(this.sr.is_contrareembolso){
      valContrareembolso='SI';
    }
    let tablaSR=new Table([
      [new Txt('Direccion: ').bold().end,this.sr.origen_direccion+' '+this.sr.origen_piso_departamento+' (CP: '+ this.sr.origen_cp+'), '+ this.sr.origen_localidad+', '+this.sr.origen_provincia],
      [new Txt('Nombre y Apellido: ').bold().end, this.sr.origen_nombre],
      [new Txt('DNI: ').bold().end, this.sr.dni],
      [new Txt('Telefono: ').bold().end, this.sr.telefono],
      [new Txt('Es contrarreembolso: ').bold().end, valContrareembolso],
      [new Txt('Valor : ').bold().end, this.sr.contrareembolso_valor]

    ]).layout('noBorders').end;
    let tablita=new Table([
      [new Txt('SR-'+ String(this.sr.id).padStart(6, '0')).bold().alignment('center').end],
      [new Txt('Remitente').bold().alignment('center').end],
      [tablaSR]
    ])
    .layout('lightHorizontalLines')

    .end;
  return new Table([
    // [new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).width(10).height(10).build(),
    [logo,
    tablita
    ]
  ]).layout('noBorders').end;
}
 createTableDestino(): ITable{
    let tablaSR=new Table([
      [new Txt('Direccion Destino: ').bold().end,this.sr.destino_direccion+' '+this.sr.destino_piso_departamento+' (CP: '+ this.sr.destino_cp+'), '+ this.sr.destino_localidad+', '+this.sr.destino_provincia],
      [new Txt('Nombre y Apellido: ').bold().end, this.sr.destino_nombre],
      [new Txt('DNI: ').bold().end, this.sr.destino_cuit],
      [new Txt('Telefono: ').bold().end, this.sr.destino_telefono],
      [new Txt('Entrecalles: ').bold().end, this.sr.destino_entrecalles]

    ]).layout('noBorders').end;
    let tablita=new Table([
      [new Txt('Destinatario').bold().alignment('center').end],

      [tablaSR]
    ])
    .layout('lightHorizontalLines')

    .end;
  return new Table([
    // [new Img('assets/crabs-logo-small.png').alignment('center').opacity(0.4).width(10).height(10).build(),
    ['',
    tablita
    ]
  ]).widths([40,'*']).layout('noBorders').end;
}

  completarRemitente(){

  }
  quitarDetalle(id:number){
    // delete this.listSrD[id-1];
    if(this.sr.id===0){
      this.listSrD.splice(id-1,1);
      let count=0;
      this.listSrD.forEach(element => {
        count=count+1
        element.id_bulto=count;
      });
    }else {
      let item =this.listSrD[id-1];
      item.estado=0


    }

  }
  async enviar(){
    // console.log(this.sr.id)
    if(this.listSrD.length>0){


      if(this.sr.id===undefined)
      {
        await this.srService.postNuevaSr(this.sr,this.listSrD).then((data:any) => {this.dialogRef.close(data);});
      }else{

        await this.srService.putSr(this.sr,this.listSrD).then((data:any) => {this.dialogRef.close(data);})
        // console.log('enviado');
      }

    }else{
      this.alertadetalle=true;
    }
  }
  agregarDetalle(){
    // this.srD.id_bulto=this.listSrD.id_bulto+1;
    let count=0;
    let item=this.srD;
    if(item.observacion===''){
      item.observacion='-';
    }
    this.listSrD.push(item);
    this.listSrD.forEach(element => {
      count=count+1
      element.id_bulto=count;
    });
    this.srD=this.srD={
      id_sr: 0,
      id_bulto:0,
      observacion:'-',
      valor_declarado:0,
      peso:0,
      estado:1
    };
  }
  franjaHoraria(id:number){
    this.sr.id_franja_horaria=id;
  }
  changeView(view:number){
    this.showSecondView = view;
  }
  onchange(direccionActiva: Direccion){

    this.sr.origen_provincia=direccionActiva.provincia;
    this.sr.origen_localidad=direccionActiva.localidad
    this.sr.origen_direccion=direccionActiva.direccion;
    this.sr.origen_cp=direccionActiva.cp;
    this.sr.origen_piso_departamento=direccionActiva.piso_dpto;
    this.sr.telefono=direccionActiva.telefono;
  }
  // onchange(direccionActiva: any){
  //   let dir = this.direcciones.filter(dir=> dir.id?.toString() === direccionActiva.toString())[0];
  //   console.log(dir);
  //   this.sr.origen_provincia=dir.provincia;
  //   this.sr.origen_localidad=dir.localidad
  //   this.sr.origen_direccion=dir.direccion;
  //   this.sr.origen_cp=dir.cp;
  //   this.sr.origen_piso_departamento=dir.piso_dpto;
  //   this.sr.telefono=dir.telefono;
  // }
  cargarDireccion(){
    // let dir = this.direcciones.filter(dir=> dir.id?.toString() === this.direccionActiva.toString())[0];

    this.sr.origen_provincia=this.direccionActiva.provincia;
    this.sr.origen_localidad=this.direccionActiva.localidad
    this.sr.origen_direccion=this.direccionActiva.direccion;
    this.sr.origen_cp=this.direccionActiva.cp;
    this.sr.origen_piso_departamento=this.direccionActiva.piso_dpto;
    this.sr.telefono=this.direccionActiva.telefono;

  }
}
